export function siteAndGroupLabel(propertyGroupId){ 
  return propertyGroupId ? 'Property Group: ' : 'Property: '
}

export function getPageKind(location){
  return window.location.pathname.split('/dialogue/')[1] || '';
}